// extracted by mini-css-extract-plugin
export default {"mCard":"kt-z","image":"lt-z","imageNoBackground":"mt-z","fullWidth":"nt-z"};